import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgApps = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "inherit",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z",
			fillRule: "nonzero"
		})
	})
});
export default SvgApps;
